/* global GLOBAL_CONFIG -- injected global configuration */
import { connectSockets, createVueI18n, registerQuasar, setDefaultRouter, useModuleStore } from '@editor/ui-utils';
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import deepmerge from 'deepmerge';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import App from './app.vue';
import { modules } from './moduleLoader.js';
import router from './router.js';

const moduleStore = useModuleStore();
let messages = {};
// Ensure the stable parent route for MainLayout exists before attaching module routes
if (!router.hasRoute('main')) {
  throw new Error('[Editor UI] Router parent route "main" not found. Dynamic module routes cannot be attached.');
}
for (const module of modules) {
  moduleStore.addModule(module);
  messages = deepmerge(messages, module.messages);
  for (const route of module.routes) {
    // Attach module routes under the "main" parent so they render inside MainLayout
    router.addRoute('main', route);
  }
}

setDefaultRouter(router);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(router);
app.use(pinia);
app.use(createVueI18n(messages));
app.use(VueQueryPlugin, { queryClient });
registerQuasar(app);
connectSockets(GLOBAL_CONFIG.API_BASE_URL, { withCredentials: true, transports: ['websocket'] }, false)
  .then(() => {
    return Promise.all(modules.map((m) => (m.init ? m.init(app) : Promise.resolve())));
  })
  .catch((e) => {
    console.error(e);
    process.exit(1);
  })
  // Call init once all modules are registered
  .finally(() => app.mount('#app'));
